import { string, bool, object, array } from 'prop-types';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import size from 'lodash/size';
import isEmpty from 'lodash/isEmpty';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { useCustomOptionValidation } from './CustomOptionValidation';
import SelectDropdown from '../SelectDropdown/SelectDropdown';
import Messages, { messagesLevels, messageTypes } from '../Messages';

import * as styles from './CustomOptions.css';

const cx = classNames.bind(styles);

const CustomOptionsDropdown = (props) => {
    const [value, setValue] = useState('');

    const {
        className,
        customFlag,
        dataItem = {},
        disableDropDown,
        disableLabel,
        input,
        isATCClicked,
        isPersonalize,
        isMTM = false,
        messageError,
        options,
        overrideDefaultValue,
        type,
        title,
        enableErrorSizing,
        validate: { personalizedItemType = false, optionName = '', CustomOptionsMessages = {} },
        selectedOptions = [],
        disableFractionSizeSelection,
    } = props;

    useEffect(() => {
        if (!disableFractionSizeSelection) {
            if (dataItem?.name === 'WIDTH - FRACTION' || dataItem?.name === 'LENGTH - FRACTION') {
                const fractionOption = selectedOptions.filter(
                    (item) => item.type === dataItem.name
                );
                if (fractionOption?.length) {
                    setValue(fractionOption[0].value);
                } else {
                    const searchParams = new URLSearchParams(window?.location?.search);
                    const fractionValue = searchParams?.get(dataItem?.name);
                    setValue(fractionValue || '');
                }
            }
        }
    }, [selectedOptions]);
    const hookParam = {
        CustomOptionsMessages,
        dataItem,
        isMTM,
        optionName,
        personalizedItemType,
        validationType: 'dropdown',
    };
    const formError = useCustomOptionValidation(hookParam, value);

    const onSelectOption = (e) => {
        const event = {
            target: {
                value: e,
            },
        };
        setValue(event.target.value);
        props.onSelectOption(dataItem, event);
    };
    const defaultOptionValueRequired = true;
    const showMessages = isATCClicked && size(messageError) > 0 && !isEmpty(formError);
    const messagesToShow = showMessages && formError ? [formError] : [];

    if (showMessages) {
        formError.type = messageTypes.warning;
    }
    return [
        <div
            className={dt([
                'order-[-1]',
                'mt-1',
                'mr-0',
                'mb-2',
                'ml-0',
                'whitespace-nowrap',
                'md:h-[10px]',
                isPersonalize && 'whitespace-normal',
                isPersonalize && 'mdOnly:w-auto',
                isPersonalize && 'lg:h-[25px]',
            ])}
        >
            {!enableErrorSizing && (
                <Messages
                    level={messagesLevels.inline}
                    messages={messagesToShow}
                    hasClose={false}
                />
            )}
        </div>,
        <div
            className={`${dt([
                'capitalize',
                'text-sm',
                'font-normal',
                'font-open-sans',
                'min-h-[15px]',
                'text-gray-40',
                'sm:!mx-0',
                'sm:!mb-2',
            ])} ${cx('row')}`}
        >
            {title}
        </div>,
        <div>
            <SelectDropdown
                {...input}
                name={(overrideDefaultValue && disableLabel) || ''}
                automationId={`custom-options-selectdropdown-${type}`}
                datasource={options}
                optionDisplayValue="name"
                optionValue="value"
                disabled={disableDropDown}
                onChangeHandler={onSelectOption} // eslint-disable-line
                defaultValueRequired={defaultOptionValueRequired}
                overrideDefaultValue={overrideDefaultValue}
                customFlag={customFlag}
                mtm={isMTM}
                value={value}
            />
        </div>,
    ];
};

CustomOptionsDropdown.defaultProps = {
    dataItem: {},
    validate: {},
    isPersonalize: false,
    input: {},
    type: '',
    options: [],
    disableDropDown: false,
    disableLabel: '',
    overrideDefaultValue: false,
    title: '',
    isMTM: false,
    customFlag: false,
    messageError: {},
    isATCClicked: false,
};

CustomOptionsDropdown.propTypes = {
    dataItem: object,
    validate: object,
    isPersonalize: bool,
    input: object,
    type: string,
    options: array,
    disableDropDown: bool,
    disableLabel: string,
    overrideDefaultValue: bool,
    title: string,
    isMTM: bool,
    customFlag: bool,
    messageError: object,
    isATCClicked: bool,
};

export default CustomOptionsDropdown;
